import React from "react";
import Cell from "./Cell";
import OrderBasicInfo from "./OrderBasicInfo";
import PickingActions from "./actions/_2_PickingActions";
import styles from "./Batch.module.scss";


export const DEFAULT_BATCH_ID = "--";

const Batch = (props) => {
  const { warehouseId, id, orders, totals } = props;

  const ordersElem = orders && Object.values(orders).map((o) => {
    const jobClasses = [
      styles.job,
      o.alert ? styles.alert : null,
    ];

    return (
      <div key={o.id} className={jobClasses.join(" ")}>
        <OrderBasicInfo
          warehouseId={warehouseId}
          className={styles.nameAndId}
          name={o.recipientName}
          jobId={o.id}
          packages={o.packages}
          alert={o.alert}
          tags={o.tags}
        />
        <PickingActions
          warehouseId={warehouseId}
          jobId={o.id}
          batchId={id}
          packages={o.packages}
          active={id !== DEFAULT_BATCH_ID}
        />
      </div>
    );
  });

  const totalsElem = totals && Object.keys(totals).map((sku) => {
    const total = totals[sku];
    return (
      <li key={sku}>{total}X {sku}</li>
    );
  });

  const headerTitle = <h2>Batch {id}</h2>;
  // NB: while waiting from the server update, the user can see the batch in
  // the picking lane with a default batchId but needs to wait until the server
  // tells us the real batch id.
  const headerAction = (
    <PickingActions
      warehouseId={warehouseId}
      batchId={id}
      allPackages={Object.values(orders).flatMap((j) => j.packages)}
      active={id !== DEFAULT_BATCH_ID}
    />
  );

  return (
    <Cell className={styles.module} title={headerTitle} actions={headerAction}>
      { ordersElem }
      <div className={styles.totals}>
        <h3>Total</h3>
        <ul>
          { totalsElem }
        </ul>
      </div>
    </Cell>
  );
}

export default Batch;